// React
import React from "react";

// Libraries
import ScrollableAnchor from 'react-scrollable-anchor';

import './login.css';

export const Team = () => {

    return (
        <ScrollableAnchor id={'team'}>
            <div className="section" id="section-3">
                <div className="section-title">The Team</div>
                <div className="section-content">
                    <div className="team">
                        <div className="team-line">
                            As engineers who build software for traders at a top bank, we know which analytics make money.
                        </div>
                        <div className="team-line">
                            As cryptocurrency traders, we recognized how difficult it can be to trade profitably without these analytics.
                        </div>
                        <div className="team-line">
                            That's why we built Yety - an application designed for traders, with tailored analytics, top security and mobile in mind.
                        </div>
                    </div>
                </div>
            </div>
        </ScrollableAnchor>
    );

};


// WEBPACK FOOTER //
// ./src/Views/Login/Team.js